import React, { useEffect, useState } from 'react';
import "../style/staff.css";
import "../style/common.css";
import api from "../utils/api";
import { ButtonComponent, InputField, PhoneNumberInput } from "../component/Common";
import Swal from "sweetalert2";
import { useNavigate } from 'react-router-dom';

const ManageStaff = () => {
    const [staffList, setStaffList] = useState([]);
    const [isInitialLoad, setIsInitialLoad] = useState(true);
    const [isDivVisible, setIsDivVisible] = useState(false);
    const [name, setName] = useState("");
    const [phone, setPhone] = useState("");
    const navigate = useNavigate();

    const showDiv = () => {
        setIsDivVisible(true);
    };

    const closeDiv = () => {
        setIsDivVisible(false);
    }

    const deleteStaff = async (id) => {
        Swal.fire({
            icon: 'question',
            iconColor: '#ab1717',
            title: 'Are you sure you want to delete staff?',
            confirmButtonText: 'Yes',
            confirmButtonColor: '#0E2F4F',
            showCancelButton: true,
            cancelButtonText: 'Cancel',
            preConfirm: async () => {
                const result = await api.post(`/delete-staff/${id}`);
                if (result.status == 200) {
                    Swal.fire({
                        icon: 'success',
                        title: result.data.message,
                        showConfirmButton: false,
                        timer: 2000,
                    });
                    fetchStaffData()
                }
            },
        })

    }

    const backButton = () => {
        navigate(-1);
    };

    const createStaff = async () => {
        try {
            const response = await api.post('/create-staff', { name, phone });
            if (response.status === 200) {
                Swal.fire({
                    icon: 'success',
                    title: response.data.message,
                    showConfirmButton: false,
                    timer: 2000,
                });
                setName("");
                setPhone("");
                setIsDivVisible(false);
                fetchStaffData()
            } else if (response.status === 201) {
                Swal.fire({
                    icon: 'error',
                    iconColor: "#AB1717",
                    title: response.data.message,
                    showConfirmButton: true,
                    confirmButtonColor: "#0E2F4F"
                    // timer: 2000,
                });
            }
        } catch (error) {
            console.error("Error creating staff:", error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error.response?.data?.message || 'Failed to create staff member. Please try again.',
                confirmButtonColor: "#0E2F4F",
            });
        }
    };

    useEffect(() => {
        setIsInitialLoad(false);
    }, []);

    useEffect(() => {
        if (!isInitialLoad) {
            fetchStaffData()
        }
    }, [isInitialLoad]);

    const fetchStaffData = async () => {
        try {
            const result = await api.get('/get-staff-list');
            if (result.status == 200) {
                setStaffList(result.data);
            } else {
                setStaffList([]);
            }

        } catch (error) {
            console.log("staff error ", error);
        }
    }

    return (
        <>
            <div className="dashboard-container">
                <div className="table-container">
                    <div className="parent-div">
                        <div className="child1" style={{ display: "flex", justifyContent: "start" }}>
                            <ButtonComponent
                                onClick={backButton}
                                name="Go Back"
                            />
                        </div>
                        <div className="child2">
                            <ButtonComponent
                                onClick={showDiv}
                                tooltipId="my-tooltip-2"
                                name="Create Staff"
                            />
                        </div>
                    </div>

                    <div className={`create_staff_div ${isDivVisible ? "open" : ""}`}>
                        <div>
                            <InputField
                                label="Enter Name:"
                                type="text"
                                htmlFor="name"
                                value={name || ""}
                                placeholder="Enter name"
                                onChange={(e) => setName(e.target.value)}
                            />
                        </div>
                        <div>
                            <PhoneNumberInput
                                label="Enter Mobile No:"
                                htmlFor="mobileNo"
                                placeholder="Enter your mobile number"
                                value={phone || ""}
                                onChange={(value) => { setPhone(value) }}
                            />
                        </div>
                        <div className="buttons-div" style={{ marginBottom: '5px' }}>
                            <ButtonComponent
                                onClick={createStaff}
                                tooltipId="create-staff-tooltip"
                                name="Create"
                            />
                            <ButtonComponent
                                onClick={closeDiv}
                                tooltipId="create-staff-tooltip"
                                name="close"
                            />
                        </div>
                    </div>
                </div>
                {staffList.length > 0 ? (
                    <div className="table-container">
                        <table>
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Phone</th>
                                    <th style={{ width: '200px' }}>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {staffList.map((row, index) => (
                                    <tr key={index}>
                                        <td>{row.name}</td>
                                        <td>{row.phone}</td>
                                        <td>
                                            <div className="action-button">
                                                <ButtonComponent name="Delete Staff" onClick={() => deleteStaff(row.id)} />
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <div className="no-data-message">
                        <p>You have not added any staff.</p>
                    </div>
                )}
            </div>
        </>
    );
};

export default ManageStaff;